( ( $ ) => {
	const $stickyEl = jQuery( '.product-single-quantity-add-btn-block' );

	if ( $stickyEl.length ) {

		const $parent = $stickyEl.parent();

		const $header = $( '#mobile-masthead' );
		const headerHeight = $header.outerHeight();

		let elementOffset = $stickyEl.offset().top - 15 - headerHeight;// margin-top 25px.

		$( window ).on( 'load resize', function () {
			if ( !$stickyEl.hasClass( 'fixed' ) ) {
				elementOffset = $stickyEl.offset().top - 15 - headerHeight;// margin-top 25px. // -
			}

		} );

		$( window ).scroll( function () {

			const scrollTop = $( window ).scrollTop();
			if ( scrollTop > elementOffset ) {
				$stickyEl.addClass( 'fixed' );
				if ( $header.is( ':visible' ) ) {
					const height = $stickyEl.height();
					$parent.css( 'padding-top', `${ height + 15 }px` )
				}

			} else {
				$stickyEl.removeClass( 'fixed' );
				$parent.css( 'padding-top', `` )
			}


		} );

	}

} )( jQuery )